"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("./styledComponents");

var _excluded = ["label", "error", "id", "required", "popover", "inputRef"];

var Input = function Input(_ref) {
  var label = _ref.label,
      error = _ref.error,
      id = _ref.id,
      required = _ref.required,
      popover = _ref.popover,
      inputRef = _ref.inputRef,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var hasError = error && error.constructor === Object && Object.keys(error).length !== 0;

  var _React$useState = _react.default.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var togglePopover = function togglePopover(event) {
    if (event) setAnchorEl(event.currentTarget);else {
      setAnchorEl(null);
    }
  };

  var open = Boolean(anchorEl);
  return /*#__PURE__*/_react.default.createElement(_styledComponents.StyledFormControl, Object.assign({
    variant: "standard"
  }, rest), label && /*#__PURE__*/_react.default.createElement(_styledComponents.StyledInputLabel, {
    error: hasError,
    required: required,
    shrink: true,
    htmlFor: id
  }, label, popover && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styledComponents.StyledIconButton, {
    onMouseEnter: togglePopover,
    onMouseLeave: function onMouseLeave() {
      return togglePopover();
    }
  }, /*#__PURE__*/_react.default.createElement(_styledComponents.StyledInfoIcon, {
    "aria-label": "popover-icon"
  })), /*#__PURE__*/_react.default.createElement(_styledComponents.StyledPopOver, {
    id: "mouse-over-popover",
    "aria-label": "popover",
    open: open,
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    onClose: function onClose() {
      return togglePopover();
    },
    disableRestoreFocus: true
  }, /*#__PURE__*/_react.default.createElement(_styledComponents.StyledInfoMessage, null, popover)))), /*#__PURE__*/_react.default.createElement(_styledComponents.StyledTextField, Object.assign({
    id: id,
    error: hasError,
    variant: "outlined",
    size: "medium",
    inputRef: inputRef
  }, rest)), hasError && /*#__PURE__*/_react.default.createElement(_styledComponents.StyledWrapperError, null, /*#__PURE__*/_react.default.createElement(_styledComponents.StyledInfoMessageTxt, null, error.message)));
};

Input.defaultProps = {
  label: '',
  popover: '',
  error: {},
  id: '',
  required: false,
  inputRef: null
};
var _default = Input;
exports.default = _default;